import { get, set } from 'dot-prop';
import { BehaviorSubject, iif, Subject, Subscription, throwError } from 'rxjs';
import {
    FieldCopy,
    FieldDefaultValue,
    FormConfigContext,
    FormDataEmitEvent,
    FormType,
    FormValueSourceEnum
} from './../../sb-form-configuration/sb-form-context';
import uuidv4 from 'uuid/v4';

import { formatDate, Location } from '@angular/common';
import { HttpClient } from '@angular/common/http';
import {
    AfterViewInit,
    ChangeDetectorRef,
    Component,
    ElementRef,
    HostListener,
    Input,
    OnDestroy,
    OnInit,
    TemplateRef,
    ViewChild,
    ViewEncapsulation
} from '@angular/core';
import { FormBuilder, FormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { MatLegacyDialog as MatDialog } from '@angular/material/legacy-dialog';
import {
    MAT_LEGACY_FORM_FIELD_DEFAULT_OPTIONS as MAT_FORM_FIELD_DEFAULT_OPTIONS,
    MatLegacyFormFieldDefaultOptions as MatFormFieldDefaultOptions
} from '@angular/material/legacy-form-field';
import { ActivatedRoute, ParamMap, Router } from '@angular/router';
import { environment } from '@environment';
import { SbHost, Sbmessage } from '@models';
import { FormlyFieldConfig, FormlyForm, FormlyFormOptions } from '@ngx-formly/core';
import {
    SbDataService,
    SbEvent,
    SbEventBusService,
    SbEventTopic,
    SbPrintService,
    SbStorageService
} from '../../services';
import {
    calculateFields,
    deepCopy,
    deepEqualsWithDates,
    getDateFromOffset,
    getFormComponentItemtext,
    getObjectDotPath,
    jsonParseDateSerializer,
    setObject,
    transformModel,
    updateCopyFields,
    getDateWithDayOffset,
    getFormControl
} from '../../../shared/utils';
import moment from 'moment';

import { SbWidgetConfigDialogComponent } from '../sb-widget-config-dialog/sb-widget-config-dialog.component';
import { TranslateService } from '@ngx-translate/core';
import { SbConfirmDialogService } from './../../sb-confirm-dialog/sb-confirm-dialog.service';
import { catchError, finalize, take, takeUntil, tap } from 'rxjs/operators';
import { AcctsService } from '../../../shared/state/accts/accts.service';
import { Badge } from 'src/app/shared/components/sb-badges/sb-badges.component';
import { Acct } from '../../../shared/state/accts/acct.model';
import { AcctsQuery } from 'src/app/shared/state/accts/accts.query';
import { fadeInOut } from 'src/app/shared/animations/fade-in-out.animation';
import { IndicatorState } from 'src/app/shared/components/sb-pending-button-indicator/sb-pending-button-indicator.component';
import { AmendService } from 'src/app/shared/services/amend.service';
import { SUBCATEGORY_MAP } from 'src/app/shared/services/amend/consts';
import {
    MAT_MOMENT_DATE_ADAPTER_OPTIONS,
    MomentDateAdapter
} from '@angular/material-moment-adapter';
import { DateAdapter, MAT_DATE_FORMATS, MAT_DATE_LOCALE } from '@angular/material/core';
import { TransactionsQuery } from 'src/app/features/transactions/state/transactions.query';

// set default form field appearance as fill for this component
const appearance: MatFormFieldDefaultOptions = {
    appearance: 'fill'
};
@Component({
    selector: 'app-sb-form-widget',
    templateUrl: './sb-form-widget.component.html',
    styleUrls: ['./sb-form-widget.component.scss'],
    providers: [
        {
            provide: MAT_FORM_FIELD_DEFAULT_OPTIONS,
            useValue: appearance
        },
        {
            provide: DateAdapter,
            useClass: MomentDateAdapter,
            deps: [MAT_DATE_LOCALE, MAT_MOMENT_DATE_ADAPTER_OPTIONS]
        },
        {
            provide: MAT_DATE_FORMATS,
            useValue: {
                parse: {
                    dateInput: 'YYYY-MM-DD',
                    monthYearLabel: 'YYYY',
                    dateA11yLabel: 'LL',
                    monthYearA11yLabel: 'YYYY'
                },
                display: {
                    dateInput: 'YYYY-MM-DD',
                    monthYearLabel: 'YYYY',
                    dateA11yLabel: 'LL',
                    monthYearA11yLabel: 'YYYY'
                }
            }
        },
        {
            provide: MAT_MOMENT_DATE_ADAPTER_OPTIONS,
            useValue: {
                useUtc: true
            }
        }
    ],
    encapsulation: ViewEncapsulation.None,
    animations: [fadeInOut]
})
export class SbFormWidgetComponent implements OnInit, OnDestroy, AfterViewInit {
    @Input() context: FormConfigContext;
    @ViewChild('filterSaveTextBox') filterSaveTextbox: ElementRef;
    @ViewChild('submissionSuccessful') submissionSuccessful: TemplateRef<any>;
    @ViewChild('formlyForm', { static: true }) formlyForm: FormlyForm;

    isReactiveForm$ = new BehaviorSubject(null);
    searchState: IndicatorState = null;
    form = new UntypedFormGroup({});
    /** An optional model object bound to the form */
    model = {};
    fields: FormlyFieldConfig[];
    options: FormlyFormOptions = {};
    msgs: Sbmessage[] = [];
    formConfigContext: FormConfigContext;
    /** Optional id of entity to be updated */
    entityId: any;
    /** Subscribe to model changes */
    modelSubscription: any;
    debug: boolean;
    routeParams: ParamMap;
    savedFilters: { name: string; id: number; model: any }[];
    enteredFilterName: string;
    filterSaveDisabled = true;
    filterSaveButtonDisabled = true;
    activeFilterName = '';
    isPrinting = false;
    subscription: Subscription;
    unsubscribe$ = new Subject();
    transactionGroupId?: number;

    initModel = {};
    prefilledModel = {};

    public printLayout$ = this.printService.isPrinting$.pipe(
        tap((printLayout) => (this.printLayout = printLayout))
    );
    printLayout: boolean;
    dateFrom: Date;
    dateEnd: Date;
    private sourceFormSub$: Subscription;
    constructor(
        private router: Router,
        private route: ActivatedRoute,
        private http: HttpClient,
        private dataService: SbDataService,
        private eventBus: SbEventBusService,
        private translateService: TranslateService,
        private storageService: SbStorageService,
        private location: Location,
        public dialog: MatDialog,
        private printService: SbPrintService,
        public confirmDialogService: SbConfirmDialogService,
        private _fb: FormBuilder,
        private _acctsService: AcctsService,
        private _acctsQuery: AcctsQuery,
        private _amendService: AmendService,
        private _cdr: ChangeDetectorRef,
        private _transactionsQuery: TransactionsQuery
    ) {
        this.entityId = route.snapshot.paramMap.get('id');
        this.debug = environment.debug;
        this.route.queryParamMap.subscribe((queryParamMap) => {
            this.routeParams = queryParamMap;
        });
    }
    ngAfterViewInit(): void {
        // If amending, group ID will be set as a query param
        this.transactionGroupId = Number(this.routeParams.get('groupId'));
        this.initModel = structuredClone(this.model);
        const [dateFrom, dateTo] = [
            this.routeParams.get('dateFrom'),
            this.routeParams.get('dateTo')
        ];
        if (dateFrom && dateTo) {
            this.dateFrom = new Date(Number(this.routeParams.get('dateFrom')));
            this.dateEnd = new Date(Number(this.routeParams.get('dateTo')));
        }
        if (this.transactionGroupId) {
            this._prefillValuesToAmend(
                this.transactionGroupId,
                this.dateFrom,
                this.dateEnd
            );
        }
    }

    reactiveForm = this._fb.group({
        period: {
            fromDate: moment(new Date()).utc().startOf('month'),
            toDate: moment(new Date()).utc().endOf('month')
        },
        date: moment(new Date()).utc().endOf('day'),
        accounts: new FormControl<Array<Acct['accountId']>>(null, Validators.required),
        showNetted: new FormControl<Boolean>(null),
        showCancelled: new FormControl<Boolean>(null)
    });

    /*** Could've done this through css but innerhtml for print div is evaluated even through component has display:none set ***/
    @HostListener('window:beforeprint', ['$event'])
    onBeforePrint(event) {
        this.isPrinting = true;
    }
    @HostListener('window:afterprint', ['$event'])
    onAfterPrint(event) {
        this.isPrinting = false;
    }

    ngOnInit(): void {
        let isReactiveForm = false; // should new form be used for this context
        switch (this.context.formId) {
            case 'transaction-filter-form':
            case 'portfolio-report-filter-form':
            case 'position-report-filter-form':
            case 'position-filter-form':
                isReactiveForm = true;
                break;
        }
        this.isReactiveForm$.next(isReactiveForm);

        switch (this.context.formId) {
            case 'transaction-filter-form':
            case 'portfolio-report-filter-form':
                this.reactiveForm.controls.period.addValidators(Validators.required);
                break;
            case 'position-report-filter-form':
            case 'position-filter-form':
                this.reactiveForm.controls.date.addValidators(Validators.required);
                break;
        }

        this.formConfigContext = this.context;
        this.fields = this.formConfigContext.formlyFieldConfigs;
        this.options = this.formConfigContext.options;

        this.model = transformModel(
            this.formConfigContext.model,
            true,
            this.formConfigContext.formModelMapping
        );

        this.initDefaultValues(this.getStoredFormModel(), this.model);
        this.initCalculatedFields();
        this.savedFilters = this.getSavedSearchFilters();
        this.registerPrintListener();
    }

    /**
     * Formats an arbitrary timestamp to fit the model, as set on change by the legacy datepicker component
     * @param timestamp
     */
    private _timestampFormatter(timestamp: number) {
        const d = new Date(timestamp);
        return new Date(Date.UTC(d.getFullYear(), d.getMonth(), d.getDate(), 0, 0, 0));
    }

    private _prefillValuesToAmend(groupId: number, fromDate?: Date, endDate?: Date) {
        const query$ = iif(
            () => !!fromDate && !!endDate,
            this._transactionsQuery.selectTransactionsByGroup$(
                groupId,
                fromDate,
                endDate
            ),
            this._transactionsQuery.selectTransactionsByGroup$(groupId)
        );
        query$
            .pipe(
                take(1),
                takeUntil(this.unsubscribe$),
                finalize(() => {
                    this._cdr.markForCheck();
                    this._storePrefilledCopy();
                })
            )
            .subscribe((group) => {
                // If group, cashflow instrument will be the one that has an ISIN or is of type 'PRIVATE_ASSET', 'PRIVATE_EQUITY', etc.
                const { initiator, cashflow } =
                    this._amendService.resolveKeyTransactionsFromGroup(group);

                if ('cash' in this.model) {
                    this.model['cash']['amount'] = `${initiator.amount}` || null;
                    this.model['cash']['currency'] =
                        initiator.instrument.currency || null;
                    // income and transfer correction have the same subcategory value but we can distinguish from the transactionType
                    let subcategory = initiator.subCategory;
                    if (initiator.subCategory === 'CORRECTION') {
                        subcategory =
                            initiator.transactionType === 'INCOME'
                                ? 'INCOME_CORRECTION'
                                : 'TRANSFER_CORRECTION';
                    }
                    this.model['cash']['subCategory'] =
                        SUBCATEGORY_MAP[subcategory] || null;
                    this.model['cash']['cashFlowInstrument'] =
                        { ...cashflow?.instrument, deleted: false } || null;
                    this.model['cash']['transactionDate'] =
                        this._timestampFormatter(initiator.transactionTimestamp) || null;

                    this.model['cash']['settlementDate'] =
                        this._timestampFormatter(initiator.settlementTimestamp) || null;
                    this.model['cash']['notes'] = initiator.transactionInfo || null;
                    this.model['cash']['tradeReference'] =
                        initiator.sourceTransactionId || null;
                }
                // TODO: this will be a bit more involved when a broker is involved
                if ('transaction' in this.model) {
                    this.model['transaction']['accountFrom'] =
                        {
                            value: initiator.accountB.accountId,
                            label:
                                initiator.accountB.accountLongName ||
                                initiator.accountB.accountShortName ||
                                initiator.accountB.accountClientAlias
                        } || null;
                    this.model['transaction']['accountTo'] =
                        {
                            value: initiator.accountA.accountId,
                            label:
                                initiator.accountA.accountLongName ||
                                initiator.accountA.accountShortName ||
                                initiator.accountA.accountClientAlias
                        } || null;
                }
                if ('transactionInfo' in this.model) {
                    this.model['transactionInfo'] = {
                        notes: initiator.transactionInfo || null,
                        tradeReference: initiator.sourceTransactionId || null
                    };
                }
            });
    }

    /**
     * Assures prefilled values have been changed before allowing the user to amend a transaction
     */
    private _formValuesChanged() {
        return !deepEqualsWithDates(this.prefilledModel, this.model);
    }

    private _storePrefilledCopy() {
        this.prefilledModel = structuredClone(this.model);
    }

    ngOnDestroy(): void {
        this.eventBus.emitEmpty(this.context.formId, SbEventTopic.FormFiltered);

        this.unsubscribe$.next(false);
        this.unsubscribe$.unsubscribe();
        this.subscription?.unsubscribe();
    }

    getSavedSearchFilters(): { name: string; id: number; model: any }[] {
        const storedFilters = this.storageService.localGet(
            this.context.formId,
            'filters'
        );
        return storedFilters ? storedFilters : [];
    }

    private initCalculatedFields() {
        if (!this.formConfigContext.calculatedFields) {
            return;
        }
        this.formConfigContext.calculatedFields.forEach((calculatedField) => {
            for (const [key, fieldTarget] of Object.entries(calculatedField.fields)) {
                const field = getObjectDotPath(fieldTarget, this.fields);
                if (field && !field.templateOptions.change) {
                    field.templateOptions.change = Function(
                        'field',
                        '$event',
                        'this.calculate($event, field)'
                    ).bind(this);
                }
            }
        });
    }

    private initDefaultValues(storedModel: any, modelToUpdate: any): void {
        if (!this.formConfigContext.defaultValues || this.entityId) {
            return;
        }
        const values = this.formConfigContext.defaultValues;
        const targetValues = values.map((dfv) => {
            const defaultValue = this.getValueFromDefault(dfv, storedModel);
            const formattedDefaultValue = this.formatDefaultValue(defaultValue, dfv);
            return { value: formattedDefaultValue, target: dfv.target };
        });
        targetValues.forEach((tv) => {
            if (tv.value) {
                setObject(tv.target, tv.value, modelToUpdate);
            }
        });
    }

    private formatDefaultValue(value: any, dfv: FieldDefaultValue): any {
        if (dfv.dateOffset) {
            // todo - why doesn't this work? (value && typeof value === 'Date')
            return getDateFromOffset(dfv.dateOffset, value ? value : new Date());
        } else if (value === 'UUID') {
            return uuidv4();
        }
        // If the default value is an identifier. Return an object with the corresponding idField set to value.
        if (dfv.idField && value !== 'object') {
            const wrappedValue = {};
            wrappedValue[dfv.idField] = value;
            return wrappedValue;
        }
        return value;
    }

    private getStoredFormModel(): any {
        return this.storageService.localGet(this.context.formId, 'lastused');
    }

    private getValueFromDefault(dfv: FieldDefaultValue, storedModel: any): any {
        switch (dfv.valueSource) {
            case FormValueSourceEnum.Route: {
                return this.routeParams.get(dfv.sourcePath);
            }
            case FormValueSourceEnum.UserProperty: {
                throw new Error('get object from property service not implemented yet');
            }
            case FormValueSourceEnum.LastSaved: {
                return get(storedModel ? storedModel : {}, dfv.target);
            }
            case FormValueSourceEnum.Value: {
                return dfv.value;
            }
            default:
                return dfv.value;
        }
    }

    calculate($event, field) {
        if (this.context.calculatedFields) {
            const filteredCalculatedFields =
                this.formConfigContext.calculatedFields.filter((value) => {
                    return Object.keys(value.fields).includes(field.key);
                });
            const _calculatedModel = calculateFields(
                { ...this.formlyForm.model },
                filteredCalculatedFields
            );
            if (_calculatedModel !== this.model) {
                this.model = _calculatedModel;
            }
        }
    }

    /** Listen to model changes and check if there are any copy field configurations.
     */
    modelChange(model) {
        if (!model) {
            return;
        }

        // Use the generic updateCopyFields for all cases
        let _model = updateCopyFields(
            model,
            this.formConfigContext.copy || [],
            this.form
        );

        // Handle special case for date fields in the convertible form
        const convertibleDatesModel = this.handleConvertibleDateFieldCopy(
            _model,
            this.formConfigContext.copy || [],
            this.form
        );

        // Combine both results without overriding
        if (convertibleDatesModel !== _model) {
            _model = { ..._model, ...convertibleDatesModel };
        }

        if (_model !== model) {
            this.model = _model;

            if (this.isFilterForm()) {
                this.submit(this.model);
            }
        }
    }

    /** @deprecated - This function has been deprecated and
     * should not be used when developing new features. */
    handleConvertibleDateFieldCopy(
        model,
        copyConfig: FieldCopy[],
        form: UntypedFormGroup
    ) {
        const _targetConfig = copyConfig.find(
            (config) =>
                config.source === 'convertible.transactionDate' &&
                config.target === 'convertible.settlementDate'
        );

        if (!_targetConfig) {
            return model;
        }

        let sourceFormControl = getFormControl(form, _targetConfig.source);
        let targetFormControl = getFormControl(form, _targetConfig.target);

        if (!sourceFormControl || !targetFormControl) {
            return model;
        }

        const initialSourceValue = sourceFormControl.value;
        if (initialSourceValue && !targetFormControl.dirty) {
            let initialTargetValue = initialSourceValue;
            if (_targetConfig.dateOffset) {
                initialTargetValue = getDateWithDayOffset(
                    initialSourceValue as Date,
                    _targetConfig.dateOffset.offset,
                    _targetConfig.dateOffset.includeWeekends
                );
            }
            targetFormControl.setValue(initialTargetValue, { emitEvent: false });
            set(model, _targetConfig.target, initialTargetValue);
        }

        if (!this.sourceFormSub$) {
            this.sourceFormSub$ = sourceFormControl.valueChanges
                .pipe(takeUntil(this.unsubscribe$))
                .subscribe((sourceValue) => {
                    let updatedTargetValue = sourceValue;
                    if (_targetConfig.dateOffset) {
                        updatedTargetValue = getDateWithDayOffset(
                            sourceValue as Date,
                            _targetConfig.dateOffset.offset,
                            _targetConfig.dateOffset.includeWeekends
                        );
                    }
                    targetFormControl.setValue(updatedTargetValue);
                });
        }
        return model;
    }

    submit(model) {
        if (!this._formValuesChanged()) {
            this.msgs = [];
            this.msgs.push({
                severity: 'error',
                summary: 'No values edited',
                detail: 'Please edit the transaction details in the form to proceed with editing'
            });
            return;
        }
        if (this.form.valid) {
            this.msgs = [];
            this.form.disable({ emitEvent: false });
            this.submitForm(model, false);
        } else {
            console.error(`Form is not valid ${this.form.errors}`);
        }
        this.printService.changeSbPrintFormData(this.getPrettyPrintedFormValues());
    }

    search(params: typeof this.reactiveForm.value) {
        if (!this.reactiveForm.valid) {
            this.searchState = 'error';
            return;
        }
        this.searchState = 'loading';
        let legacyFormat;
        let printContent;
        const accounts = this._acctsQuery.getAll({ asObject: true });
        switch (this.context.formId) {
            case 'portfolio-report-filter-form':
                legacyFormat = {
                    portfolio: {
                        fromDate: params.period.fromDate.toDate().toISOString(),
                        toDate: params.period.toDate.endOf('day').toDate().toISOString(),

                        //...params.period,
                        accounts: params.accounts
                    }
                };

                printContent = `
                <div class="portfolio-report-title">
                    <h1>Portfolio report</h1>
                    <p>From <strong>${formatDate(
                        this.reactiveForm.value.period.fromDate.toDate(),
                        'shortDate',
                        'sv',
                        'UTC'
                    )}</strong>
                    to <strong>${formatDate(
                        this.reactiveForm.value.period.toDate.toDate(),
                        'shortDate',
                        'sv',
                        'UTC'
                    )}</strong></p>
                </div>`;
                break;
            case 'transaction-filter-form':
                legacyFormat = {
                    transaction: {
                        fromDate: params.period.fromDate.toDate().toISOString(),
                        toDate: params.period.toDate.endOf('day').toDate().toISOString(),
                        accounts: params.accounts,
                        showCancelled: params.showCancelled
                    }
                };

                printContent = `
<div class="sb-confirmation-content px-2 ms-n4">
    <div class="sb-confirmation-key">Accounts:</div>
    <div class="sb-confirmation-value text-left">${this.reactiveForm.value.accounts
        .map((account) => accounts[account].accountClientAlias)
        .join(', ')}</div>
</div>
<div class="sb-confirmation-content px-2">
    <div class="sb-confirmation-key">From:</div>
    <div class="sb-confirmation-value text-nowrap">${formatDate(
        this.reactiveForm.value.period.fromDate.toDate(),
        'shortDate',
        'sv',
        'UTC'
    )}</div>
</div>
<div class="sb-confirmation-content px-2 me-n3">
    <div class="sb-confirmation-key">To:</div>
    <div class="sb-confirmation-value text-nowrap">${formatDate(
        this.reactiveForm.value.period.toDate.toDate(),
        'shortDate',
        'sv',
        'UTC'
    )}</div>
</div>`;
                break;
            case 'position-report-filter-form':
                legacyFormat = {
                    position: {
                        positionDate: params.date.endOf('day').toDate().toISOString(),
                        accounts: params.accounts
                    }
                };
                printContent = `
<div class="sb-confirmation-content px-2 ms-n4">
    <div class="sb-confirmation-key">Accounts:</div>
    <div class="sb-confirmation-value text-left">${this.reactiveForm.value.accounts
        .map((account) => accounts[account].accountClientAlias)
        .join(', ')}</div>
</div>
<div class="sb-confirmation-content px-2">
    <div class="sb-confirmation-key">Date:</div>
    <div class="sb-confirmation-value text-nowrap">${formatDate(
        this.reactiveForm.value.date.toDate(),
        'shortDate',
        'sv',
        'UTC'
    )}</div>
</div>`;
                break;
            case 'position-filter-form':
                legacyFormat = {
                    position: {
                        positionDate: params.date.endOf('day').toDate().toISOString(),
                        accounts: params.accounts,
                        showNetted: params.showNetted
                    }
                };
                printContent = `
<div class="sb-confirmation-content px-2 ms-n4">
    <div class="sb-confirmation-key">Accounts:</div>
    <div class="sb-confirmation-value text-left">${this.reactiveForm.value.accounts
        .map((account) => accounts[account].accountClientAlias)
        .join(', ')}</div>
</div>
<div class="sb-confirmation-content px-2">
    <div class="sb-confirmation-key">Date:</div>
    <div class="sb-confirmation-value text-nowrap">${formatDate(
        this.reactiveForm.value.date.toDate(),
        'shortDate',
        'sv',
        'UTC'
    )}</div>
</div>`;
                break;
        }
        this.printService.changeSbPrintFormData(printContent);
        // TODO: should return success when data is loaded
        setTimeout(() => {
            this.searchState = 'success';
        }, 3000);
        this.submitForm(legacyFormat, false);
    }

    saveFilter(params: typeof this.reactiveForm.value) {
        if (this.reactiveForm.valid) {
            this.quickFilters = [
                ...this.quickFilters,
                { title: 'New filter', data: params }
            ];
        }
    }

    loadFilter(filter: typeof this.reactiveForm.value) {
        // update form values based on filter
        this.reactiveForm.patchValue(filter);
        // perform search using updated form values
        this.search(this.reactiveForm.value);
    }

    quickFilters: Array<Badge<typeof this.reactiveForm.value>> = [];

    onUpdateInitialValue() {
        if (this.formlyForm.options) {
            this.formlyForm.options.updateInitialValue();
        }
    }

    defaultButtonLabel(): string {
        return this.isFilterForm()
            ? 'Search'
            : this.routeParams.get('groupId')
            ? 'Edit'
            : 'Submit';
    }

    onReset() {
        if (this.formlyForm.options) {
            this.model = { ...structuredClone(this.initModel), correlationId: uuidv4() };
            this.formlyForm.options.resetModel();
        }
    }

    private submitForm(model, isConfirmed: boolean) {
        const body = this.getSubmitModel(model);

        if (this.isFilterForm()) {
            this.emitFormData(body);
            this.storeUsedValues();
            this.filterSaveDisabled = false;
        } else {
            if (!isConfirmed) {
                this.confirmDialogService
                    .confirmDialog({
                        title: 'Confirmation',
                        message: this.getPrettyPrintedFormValues(),
                        cancelText: `Cancel`,
                        confirmText: `Submit`
                    })
                    .subscribe((res) => {
                        if (res) {
                            this.submitForm(model, true);
                        } else {
                            this.form.enable({ emitEvent: false });
                        }
                    });
            } else {
                const transactionGroupId = this.routeParams.get('groupId');
                if (transactionGroupId) {
                    this._amendService
                        .amendTransaction(Number(transactionGroupId), body)
                        .pipe(
                            catchError((err) =>
                                throwError(() => this.handleFailedSubmit(err))
                            )
                        )
                        .subscribe((response) => {
                            this.handleSuccessfulSubmit(response);
                            return;
                        });
                } else {
                    this.storeUsedValues();
                    this.emitSelectedValues(model, this.context.formDataEmitEvents);
                    this.entityId ? this.updateEntity(body) : this.createEntity(body);
                }
            }
        }
    }

    /** Emits events based on values in the object model */
    private emitSelectedValues(model: any, formDataEmitEvents: FormDataEmitEvent[]) {
        formDataEmitEvents?.map((formDataEvent) => {
            const payload = get(model, formDataEvent.source);
            const emitEvent: SbEvent = {
                ...formDataEvent.event,
                payload: {
                    value: payload
                }
            };
            this.eventBus.emit(emitEvent);
        });
    }

    private storeUsedValues() {
        if (
            this.context.defaultValues &&
            this.context.defaultValues.some(
                (dfv) => dfv.valueSource === FormValueSourceEnum.LastSaved
            )
        ) {
            this.storageService.localSet(this.context.formId, 'lastused', this.model);
        }
    }

    private getPrettyPrintedFormValues() {
        // Filter out the ones without labels --> hidden fields with no labels should not be displayed in confirmation.
        const valuesWithLabels = this.getKeysAndLabels().filter((gkv) => gkv.label);
        return this.getPrettyKeyValueHtml(valuesWithLabels);
    }

    private getPrettyKeyValueHtml(gkv: GroupKeyValueRow[]): string {
        return gkv.map((v) => this.getPrettyGroupKeyValueRow(v)).join('');
    }

    private getPrettyGroupKeyValueRow(gkv: GroupKeyValueRow): string {
        if (!this.printLayout) {
            if (gkv.isGroupNode) {
                return gkv.includeGroupNodeLabel ? `<h3>${gkv.label}</h3>` : '';
            } else {
                // * is set directly in the configuration for labels to indicate mandatory fields. Should be moved to code?
                return `<div class='sb-confirmation-content'><div class='sb-confirmation-key'>${gkv.label.replace(
                    '*',
                    ''
                )}:</div> <div class='sb-confirmation-value'>${
                    gkv.formattedValue ? gkv.formattedValue : ''
                }</div></div>`;
            }
        } else {
            return `<div class='print-layout sb-confirmation-content'>
                <div class='sb-confirmation-key'>
                  ${gkv.label.replace('*', '')}:
                </div>
                <div class='sb-confirmation-value print-layout'>
                  ${gkv.formattedValue ? gkv.formattedValue : ''}
                </div>
              </div>`;
        }
    }

    private getKeysAndLabels() {
        const fields = this.fields;
        const res: GroupKeyValueRow[] = [];
        fields.forEach((f) => {
            this.addKeyLabelRowFromField(f, res, null);
        });
        return res;
    }
    private addKeyLabelRowFromField(
        f: FormlyFieldConfig,
        res: GroupKeyValueRow[],
        parentKey: string
    ) {
        const label = f.templateOptions?.label;
        const fieldGroup = f.fieldGroup;
        const isGroupNode = f.fieldGroup ? true : false;

        let key = null;
        // In a nested fieldGroup hierarchy the fieldKey may be empty --> pass the previous key in the hierarchy.
        if (f.key != null) {
            key = parentKey != null ? parentKey + '.' + f.key : f.key;
        } else {
            key = parentKey;
        }

        const includeGroupNodeLabel =
            f.templateOptions?.label !== '' && f.templateOptions?.label ? true : false;
        const value = isGroupNode ? null : get(this.model, key);
        const componentItemText = getFormComponentItemtext(
            value,
            f.templateOptions?.templateFields
        );
        const formattedValue = this.getFormattedFormComponentItemText(
            componentItemText,
            f
        );
        const valueLabelRow = {
            label,
            key,
            isGroupNode,
            includeGroupNodeLabel,
            formattedValue
        };
        res.push(valueLabelRow);
        if (fieldGroup) {
            fieldGroup.forEach((fc) => this.addKeyLabelRowFromField(fc, res, key));
        }
    }
    getFormattedFormComponentItemText(formattedValue: any, f: FormlyFieldConfig): string {
        if (formattedValue instanceof Array) {
            return formattedValue
                .map((fv) => this.getFormattedFormComponentItemText(fv, f))
                .join('<br/>');
        } else if (formattedValue instanceof Date) {
            if (f.type && f.type === 'sb-timepicker') {
                return formattedValue.toLocaleTimeString();
            }
            return formattedValue.toLocaleDateString();
        } else if (f.templateOptions) {
            if (f.templateOptions.type === 'password') {
                return '********';
            }
            if (f.templateOptions.type === 'switch') {
                return formattedValue ? formattedValue : 'false';
            }
            if (
                f.templateOptions.type === 'select' &&
                f.templateOptions.options instanceof Array
            ) {
                const option = f.templateOptions.options.find(
                    (o) => o.value === formattedValue
                );
                return option && option.label
                    ? option.label
                    : option
                    ? option.value
                    : formattedValue;
            }
            if (
                f.type &&
                f.type === 'radio' &&
                f.templateOptions.options instanceof Array
            ) {
                const option = f.templateOptions.options.find(
                    (o) => o.value === formattedValue
                );
                return option.label ? option.label : option.value;
            }
        }
        return formattedValue;
    }

    isFilterForm(): boolean {
        return this.context.formType === FormType.Filter;
    }

    filterButtonClicked(event: any) {
        const filterId = parseInt(event.currentTarget.id);
        const filterName = event.target.textContent;
        const filtername = this.savedFilters.map((f) => {
            f.name === filterName;
            return f;
        });
        const filter = filtername.find((f) => f.id === filterId);
        if (filter) {
            this.activeFilterName = filterName;
            const _model = deepCopy(this.model);
            this.setFilterValues(
                _model,
                JSON.parse(filter.model, jsonParseDateSerializer)
            );
            this.model = _model;
            setTimeout(() => {
                this.submit(this.model);
                this.filterSaveDisabled = true;
            }, 0);
            // Filter save gets enabled when searching.
            // In this case, disable it until user has changed values in form and done a new search.
        }
    }

    private setFilterValues(modelToUpdate: any, storedModel: any) {
        if (
            !this.formConfigContext.defaultValues ||
            this.formConfigContext.defaultValues.length === 0
        ) {
            Object.assign(modelToUpdate, storedModel);
        } else {
            const values = this.formConfigContext.defaultValues.filter(
                (dfv) => !dfv.excludeInSavedFilters
            );
            const targetValues = values.map((dfv) => {
                return {
                    value: get(storedModel ? storedModel : {}, dfv.target),
                    target: dfv.target
                };
            });
            targetValues.forEach((tv) => {
                if (tv) {
                    setObject(tv.target, tv.value, modelToUpdate);
                }
            });
        }
    }

    public updateFilter(isConfirmed: boolean, filterName: string) {
        if (!isConfirmed) {
            this.confirmDialogService
                .confirmDialog({
                    title: 'Confirm Filter Update',
                    message: `This will overwrite the previous filter values with the current values in the filter form. Are you sure? <br/><br/><h2>Filter: ${filterName}</h2>`,
                    cancelText: `No`,
                    confirmText: `Yes`
                })
                .subscribe((res) => {
                    if (res) {
                        this.updateFilter(true, filterName);
                    }
                });
        } else {
            const filterToUpdate = this.savedFilters.find((f) => f.name === filterName);
            filterToUpdate.model = JSON.stringify(this.model);
            this.storageService.localSet(
                this.context.formId,
                'filters',
                this.savedFilters
            );
        }
    }

    public deleteFilter(isConfirmed: boolean, filterName: string) {
        if (!isConfirmed) {
            this.confirmDialogService
                .confirmDialog({
                    title: 'Delete Record Confirmation',
                    message: `Are you sure you want to remove this search filter? This operation cannot be undone. <br/><br/><h2>Filter: ${filterName}</h2>`,
                    cancelText: `No`,
                    confirmText: `Yes`
                })
                .subscribe((res) => {
                    if (res) {
                        this.deleteFilter(true, filterName);
                    }
                });
        } else {
            this.savedFilters = this.savedFilters.filter((f) => f.name !== filterName);
            this.storageService.localSet(
                this.context.formId,
                'filters',
                this.savedFilters
            );
        }
    }

    public createFilter(event: any) {
        this.filterSaveButtonDisabled = true;
        this.filterSaveDisabled = true;
        const filterToSave = {
            id: this.savedFilters.length + 1,
            name: this.enteredFilterName,
            model: JSON.stringify(this.model)
        };
        this.savedFilters.push(filterToSave);
        this.storageService.localSet(this.context.formId, 'filters', this.savedFilters);
        this.activeFilterName = this.enteredFilterName;
        // Clear text field
        this.filterSaveTextbox.nativeElement.value = '';
        this.enteredFilterName = '';
    }

    public onFilterTextKeyUp(enteredText: string) {
        // todo - set delay here?
        this.enteredFilterName = enteredText;
        this.filterSaveButtonDisabled = this.enteredFilterName ? false : true;
    }

    private emitFormData(body: any): void {
        // Submit on event topic
        const payload: SbEvent = {
            source: this.context.formId,
            topic: SbEventTopic.FormFiltered,
            payload: body
        };
        this.eventBus.emit(payload);
        this.form.enable();
    }

    private getSubmitModel(model) {
        const transformedModel = transformModel(
            model,
            false,
            this.formConfigContext.formModelMapping
        );
        this.formlyForm.modelChange.emit();
        return transformedModel;
    }

    private createEntity(body: any): void {
        const method = this.formConfigContext.path.httpMethod;
        const url = this.dataService.getResourceUrl(
            this.formConfigContext.path,
            SbHost.GatewayBaseUrl
        );
        this.http
            .request(method, url, {
                body
            })
            .subscribe(
                (response) => this.handleSuccessfulSubmit(response),
                (err) => this.handleFailedSubmit(err)
            );
    }

    private updateEntity(body: any): void {
        const method = 'PUT';
        const url = this.dataService.getSingleResourceUrl(
            this.formConfigContext.path,
            SbHost.GatewayBaseUrl,
            this.entityId
        );
        this.http
            .request(method, url, {
                body
            })
            .subscribe(
                (response) => this.handleSuccessfulSubmit(response),
                (err) => this.handleFailedSubmit(err)
            );
    }

    private handleSuccessfulSubmit(responseData) {
        this.form.enable();
        if (this.formConfigContext.emitResponseDataOnSuccess) {
            const emitEvent: SbEvent = {
                ...this.formConfigContext.emitResponseDataOnSuccess,
                payload: {
                    value: responseData
                }
            };
            this.eventBus.emit(emitEvent);
        }
        this.onReset();
        this.msgs = [];
        this.msgs.push({
            severity: 'success',
            summary: 'Transaction submitted successfully!',
            footerTemplate: this.submissionSuccessful
        });
    }

    private handleFailedSubmit(data) {
        let detail = '';
        if (data.error?.error?.hasOwnProperty('errors')) {
            data.error.error.errors.forEach((error) => {
                detail = detail.concat(this.translateService.instant(error.message));
            });
        } else if (data.hasOwnProperty('error')) {
            detail = this.translateService.instant(data.message);
        }
        this.form.enable();
        this.msgs = [];
        this.msgs.push({
            severity: 'error',
            summary: 'Failed to submit form',
            detail: detail
        });
    }

    registerPrintListener() {
        this.subscription = this.eventBus.getObservable(SbEventTopic.Print).subscribe(
            (event) => {
                if (event) {
                    if (event.payload === 'Printing') {
                        this.isPrinting = true;
                    } else {
                        this.isPrinting = false;
                    }
                }
            },
            (error) => console.error(error)
        );
    }

    /*
     * Used for dev mode to visualize and edit widget configuration from front end.
     */
    openConfigurationDialog() {
        this.dialog.open(SbWidgetConfigDialogComponent, {
            data: this.context
        });
    }
}

export class GroupKeyValueRow {
    label: string;
    key: string;
    isGroupNode: boolean;
    includeGroupNodeLabel: boolean;
    formattedValue: any;
}
